export default {
  // filter中条件筛选、日期筛选都不显示
  noFilter: [
    '/analytics/overview/app',
    '/analytics/overview/quality',
    '/manage/overview',
    '/helper/eauth',
    '/analytics/user/group',
    'analytics/user/group/edit',
    '/analytics/user/userPortrait',
    '/analytics/behavior/smart',
    '/helper/err/detail',
    '/analytics/behavior/funnel',
    '/analytics/behavior/funnel/setfunnel',
  ],
};
